import { render, staticRenderFns } from "./detailSms.vue?vue&type=template&id=43a04275&scoped=true&"
import script from "./detailSms.vue?vue&type=script&lang=js&"
export * from "./detailSms.vue?vue&type=script&lang=js&"
import style0 from "./detailSms.vue?vue&type=style&index=0&id=43a04275&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a04275",
  null
  
)

export default component.exports